<template>
<div>
  <v-layout  v-if="changePWDialog" style="padding-top: 150px">
    <v-flex xs12 sm12 md12 lg12>
      <div>
        <v-card class="mx-auto" max-width="500" outlined
        >
          <v-img :src="require('../assets/splash.jpg')" />
          <v-overlay
            opacity="0.6"
            absolute
            color="black"
            style="padding: 10px;"
          >
          <v-card-title class="justify-center"><h3>{{title}}</h3></v-card-title>
          <v-divider />
          <p>{{msg}}</p>
          <ValidationObserver ref="observer" >
            <ValidationProvider
              name="oldpassword"
              ref="oldpassword"
              rules="required"
              :bails="false"
            >
              <v-text-field
                prepend-icon="lock"
                class="mt-5"
                v-model="oldpassword"
                :append-icon="show0 ? 'visibility' : 'visibility_off'"
                :type="show0 ? 'text' : 'password'"
                label="Current Password"
                counter
                @click:append="show0 = !show0"
                outlined
                v-on:keyup.enter="submit"
              ></v-text-field>
            </ValidationProvider>
            <ValidationProvider
              name="newpassword1"
              ref="newpassword1"
              rules="required"
              :bails="false"
            >
              <v-text-field
                prepend-icon="lock"
                class="mt-5"
                v-model="newpassword1"
                :append-icon="show1 ? 'visibility' : 'visibility_off'"
                :type="show1 ? 'text' : 'password'"
                label="New Password"
                counter
                @click:append="show1 = !show1"
                outlined
                v-on:keyup.enter="submit"
              ></v-text-field>
            </ValidationProvider>
            <ValidationProvider
              name="New Password"
              ref="newpassword2"
              rules="required|passwordMatch:@newpassword1"
              v-slot="{ errors }"
              :bails="false"
            >
              <v-text-field
                prepend-icon="lock"
                class="mt-5"
                v-model="newpassword2"
                :append-icon="show2 ? 'visibility' : 'visibility_off'"
                :type="show2 ? 'text' : 'password'"
                label="Confirm New Password"
                counter
                @click:append="show2 = !show2"
                outlined
                v-on:keyup.enter="submit"
              ></v-text-field>
              <ul style="color: red" class="overline text-left">
                <li v-for="(error, index) in errors" :key="index">
                  <span>{{ error }}</span>
                </li>
              </ul>
            </ValidationProvider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn :disabled="!valid" @click="submit()" text>Change Password</v-btn>
              <v-btn @click="cancel" text>cancel</v-btn>
            </v-card-actions>
          </ValidationObserver>
          </v-overlay>
        </v-card>
      </div>
    </v-flex>
  </v-layout>
  </div>
</template>

<script>
import Vue from 'vue'
import {ValidationProvider, extend} from "vee-validate/dist/vee-validate.full"
import { ValidationObserver } from "vee-validate/dist/vee-validate.full"
import { sync } from "vuex-pathify"
import axiosInstances from '../server/axiosInstances'
extend("required", {
  message: (field, values) => "You must enter a " + `${field}` + " value",
});
// create custom error message for custom rule
var errorMessage =
  " min length 8 chars, and must include 1 lower-case, upper-case, numeral and special character (#!@$%^*-)";
// create custom rule
extend("passwordMatch", {
  params: ['target'],
  message: (field) => "The " + `${field}` + errorMessage,
  validate: (value, {target}) => {
    var notTheseChars = /["'?&/<>\s]/;
    var mustContainTheseChars = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#!@$%^*-]).{8,}$/;
    var containsForbiddenChars = notTheseChars.test(value);
    // var containsRequiredChars = mustContainTheseChars.test(value);
    if (value == target && !containsForbiddenChars) {
      return true;
    } else {
      if (containsForbiddenChars) {
        errorMessage =
          ' contains forbidden characters: " ' + " ' ? & / < > or space";
      } else if (value!= target) {
        errorMessage = " fields must match"
      } else {
        errorMessage =
          " min length 8 chars, and must include 1 lower-case,upper-case, numeral and special character ($@$!%*#?&)";
      }
      return false;
    }
  },
});
export default {
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  data: () => ({
    show0: false,
    show1: false,
    show2: false,
    oldpassword: "",
    newpassword1: "",
    newpassword2: "",
    title: "Change",
    msg: "Passwords are case sensitive",
    resetPassword: false,
  }),
  computed: {
    changePWDialog: sync('login/changePWDialog'),
    valid() {
      return (this.oldpassword.length != 0 && this.newpassword1 == this.newpassword2)
    },
  },
  methods: {
    async submit () {
      this.msg = "Changing password..."
      try {
        let res = await axiosInstances.authServer.post('misc/changepwbyuser',
        {
          'old': this.oldpassword,
          'new': this.newpassword1
        })
        console.log(res)
        this.msg = "Password Changed"
        var self = this
        setTimeout(function() {
          self.changePWDialog = false
        }, 2000)
      } catch (ex) {
        this.msg = "Password change failed. You may have entered incorrect current password. Please try again"
        console.log(ex)
      }
    },
    cancel() {
      this.changePWDialog = false;
    },
  },
  watch: {
  },
  mounted() {
    this.title = "Change Password"
    this.msg = "Passwords are case sensitive"
  },
};
</script>

